import type { FlagConfiguration } from '@atlassian/jira-flags';
import { toFlagId } from '@atlassian/jira-flags/src/services/types';
import { DISMISS_ERROR_FLAG_ID } from '../../../constants';
import { messages } from './messages';

export const getErrorFlagOnDismiss = (): FlagConfiguration => ({
	key: toFlagId(DISMISS_ERROR_FLAG_ID),
	type: 'error',
	title: messages.title,
	description: messages.description,
});
